import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";

export const phone = (props) => {
  return <PhoneRoundedIcon {...props} />;
};
